<!-- @format -->
<div class="modal-content templateUploader">
   <!--  TITLE HEADER-->
   <div class="modal-header">
      <button type="button" class="close" (click)="closeDialog()" aria-hidden="true">×</button>
      <h3 id="myModalLabel">Tags Mapping AR2 to AR3</h3>
   </div>

   <!--  BODY -->
   <div class="modal-body row">
      <div class="col-md-12">
         <p-table #dt [value]="tagViewItems" [columns]="cols" class="custom-table">
            <ng-template pTemplate="colgroup" let-columns>
               <colgroup>
                  <col *ngFor="let col of columns" [style.width]="col.width" />
               </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
               <tr>
                  <th *ngFor="let col of columns">{{ col.header }}</th>
               </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tagView>
               <tr>
                  <td>{{ tagView.ar2tag }}</td>
                  <td><span [innerHTML]="tagView.safeHtml"></span></td>
               </tr>
            </ng-template>
         </p-table>
      </div>
   </div>

   <!--  FOOTER-->
   <div class="modal-footer">
      <button class="btn btn-default" aria-hidden="true" (click)="closeDialog()">Close</button>
   </div>
</div>
